import RentalIncomeCard from "./RentalIncomeCard";

const RentalIncomeCardContainer = ({
  totalIncomeChart,
  activePosition,
}: {
  totalIncomeChart: any;
  activePosition: 10 | 20 | 30;
}) => {
  return (
    <RentalIncomeCard
      totalIncomeChart={totalIncomeChart}
      activePosition={activePosition}
    />
  );
};

export default RentalIncomeCardContainer;
